import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div className="loading-screen">
            <div className="loading-spinner"></div>
        </div>
    );
};

export default Loading;